import { ShieldCheck, BadgeCheck, Building2, MapPin } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Insured" },
  { icon: BadgeCheck, label: "Free Estimates" },
  { icon: Building2, label: "Residential & Commercial" },
  { icon: MapPin, label: "Greensboro, NC" },
];

export default function TrustBar() {
  return (
    <section className="bg-ink text-white" aria-label="Credentials" data-testid="trust-bar">
      <div className="container-x">
        <ul className="flex overflow-x-auto no-scrollbar divide-x divide-white/10 -mx-5 px-5 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-4">
          {ITEMS.map(({ icon: Icon, label }) => (
            <li
              key={label}
              className="flex items-center justify-center gap-3 py-6 px-6 min-w-[62%] sm:min-w-0 shrink-0"
            >
              <Icon size={20} strokeWidth={1.5} className="text-blush shrink-0" aria-hidden="true" />
              <span className="eyebrow !tracking-[0.2em] whitespace-nowrap text-white/90">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
